import { GetSpacesAttributtesApi } from "@/features/private-room/bookings/adapters/get-spaces-attributes";

export const getSpaceTakeValue = async (spaceId: number) => {
  const data = await GetSpacesAttributtesApi(spaceId);

  const spaceTake = data.find(
    (item) => item.spaceattribute.name === "space_pvtoffice_take",
  );

  return spaceTake?.spaceattribute?.content || "16";
};
